import {List, SxProps} from '@mui/material';
import {FC} from 'react';
import {useRecoilValueLoadable} from 'recoil';
import {LoadableHelpers} from '../../../../shared/helpers/loadableHelpers';
import {managerListSelector} from '../store/manager-list.store';
import {ManagerListItem} from './manager-list-item';

const STYLES = {
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
} as const satisfies Record<string, SxProps>;

export const ManagerList: FC = () => {
  const loadable = useRecoilValueLoadable(managerListSelector);

  return (
    <List style={STYLES.list}>
      {LoadableHelpers.withDefault(loadable, []).map((manager) => (
        <ManagerListItem key={manager.id} user={manager} />
      ))}
    </List>
  );
};
